import {Type} from "class-transformer";
import {serializeType} from "@app/shared";

export class LedgerBalanceInfo {
  name: string;
  periodBalance: number;
  ytdBalance: number;
}

export class LedgerBalances {
  id: number;
  version: number;
  ytdBalance: number;
  periodBalance: number;
  fiscalYearLedgerAccountBalanceId: number;
  accountingPeriodId: number;
  periodStart: string;
  periodEnd: string;
}

export class LedgerBudget {
  id: number;
  version: number;
  year: string;
  initialBalance: number;
  initialBalancePosted: boolean;
  targetBalance: number;
  forecastBalance: number;
  fiscalYearLedgerAccountBalanceId: number;
}

export class LedgerEntries {
  id: number;
  version: number;
  journalCode: string;
  entryDate: string;
  // entryType: string;
  name: string;
  memo: string;
  refId: number;
  creditAmount: number;
  debitAmount: number;
  transaction: string;
  processed: boolean;
  fiscalYearLedgerAccountBalanceId: number;
  accountingPeriodId: number;
  accountNumber: number;
  accountName: string;
  periodEnd: Date;
  periodStart: string;
  periodName: string;
}

export class LedgerAccount {
  id?: number;
  version?: number;
  year: string;
  ytdBalance: number;
  accountId: number;
  active: boolean;
  accountTypeName: string;
  accountName: string;
  accountNumber: number;
  parentFiscalYearAccountId: number;
  expanded?: boolean;
  @Type(serializeType(LedgerAccount)) children?: LedgerAccount[];
  @Type(serializeType(LedgerBalances)) ledgerBalances: LedgerBalances[];
  @Type(serializeType(LedgerEntries)) ledgerEntries: LedgerEntries[];
  @Type(serializeType(LedgerBudget)) ledgerBudget: LedgerBudget;
  @Type(serializeType(LedgerBalanceInfo)) ledgerBalanceInfos: LedgerBalanceInfo[];
}
